export const FETCH_ASSETSHARECLASS_BEGIN="FETCH_ASSETSHARECLASS_BEGIN";
export const FETCH_ASSETSHARECLASS_SUCCESS="FETCH_ASSETSHARECLASS_SUCCESS";
export const FETCH_ASSETSHARECLASS_FAILURE="FETCH_ASSETSHARECLASS_FAILURE";

export const FETCH_ASSETSHARECLASSDETAILS_BEGIN="FETCH_ASSETSHARECLASSDETAILS_BEGIN";
export const FETCH_ASSETSHARECLASSDETAILS_SUCCESS="FETCH_ASSETSHARECLASSDETAILS_SUCCESS";
export const FETCH_ASSETSHARECLASSDETAILS_FAILURE="FETCH_ASSETSHARECLASSDETAILS_FAILURE";

export const FETCH_ASSETSHARECLASSFEEDETAILS_BEGIN="FETCH_ASSETSHARECLASSFEEDETAILS_BEGIN";
export const FETCH_ASSETSHARECLASSFEEDETAILS_SUCCESS="FETCH_ASSETSHARECLASSFEEDETAILS_SUCCESS";
export const FETCH_ASSETSHARECLASSFEEDETAILS_FAILURE="FETCH_ASSETSHARECLASSFEEDETAILS_FAILURE";